export default __webpack_public_path__ + "static/media/usBank.ba4cfd31.svg";